export const REVALIDATED_KEYS = [
  "stakedTokens",
  "ownedTokens",
  "rewardPerToken",
];
